<template>
  <div class="aviso-listagem">
    <slot />
  </div>
</template>
<script setup></script>
<style scoped>
.aviso-listagem {
  text-align: center;
  padding: 30px;
  font-size: 1.1em;
  color: var(--cinza-escuro);
  background-color: var(--branco);
  border-radius: 10px;
  border: 1px dashed var(--cinza-claro);
  margin-top: 20px;
}
</style>
